import {
  GxButton,
  GxCheckbox, GxForm,
  GxIcon,
  GxTextarea
} from '@garpix/garpix-web-components-react';
import cnBind from 'classnames/bind';
import { useFormik } from 'formik';
import React, {memo, useState} from 'react';
import DatePicker from 'react-multi-date-picker';
import TimePicker from 'react-multi-date-picker/plugins/time_picker';
import { useNavigate } from 'react-router-dom';
import { useStoreon } from 'storeon/react';
import { State } from '@/interfaces';
import {MODALS_NAMES} from '../../const/modals';
import useModal from '../../hooks/useModal';
import { PlusIcon, UserIcon} from '../../assets';
import CalendarInput from '../../components/CalendarInput';
import Input from '../../components/Input';
import Switcher from '../../components/Switcher';
import InputUploadFile from '../../components/InputUploadFile';
import { months, weekDays } from '../../const/calendar';
import { createTaskSchemaStaff, createTaskSchemaSuperAdmin } from '../Applications/schema';
import MultiSelectUsers from './components/MultiSelectGroups';
import SelectOrders from './components/SelectOrders';
import { defaultValueTabsGroup,
  initialValuesTask
} from './const';
import styles from './styles/index.module.scss';
import {handleSubmit} from './helpers';
import dayjs from '../../utils/dayjs'
import TypeTaskSelect from './components/TypeTaskSelect';
import TabGroupsUser from './components/TabGroupsUser';
import TabGroupsReminder from './components/TabGroupsReminder';
import TabGroupsRepeat from './components/TabGroupsRepeat';
import SelectStaff from './components/SelectStaff';
import {TYPE_USER} from '../../const';
import { IFormikState } from './interfaces';

const CreateTask = () => {
  const navigate = useNavigate()
  const cn = cnBind.bind(styles);
  const { page } = useStoreon('page');
  const {openModal,openModalCall} = useModal();
  const { currentUser } = useStoreon<State>('currentUser');
  const { site_configuration } = page?.data?.page?.global;
  const [tabGroups, setTabGroups] = useState<Record<string, any>>(defaultValueTabsGroup);

  const handleClickTab = (name: string) => {
    setTabGroups({
      ...tabGroups,
      [name]: { status: !tabGroups[name].status }
    })
  }

  const openModalUserEdit = (user: Record<string, any>): void => {
    openModal(MODALS_NAMES.modalUser, {isEdit: true, userId: user.value})
  }

  const openModalUser = (): void => {
    openModal(MODALS_NAMES.modalUser, {isEdit: false})
  }
  const formik = useFormik<IFormikState>({
    enableReinitialize: true,
    initialValues: initialValuesTask(currentUser),
    validationSchema: currentUser.user_status === 'superuser' ? createTaskSchemaSuperAdmin : createTaskSchemaStaff,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (value) => handleSubmit(value ,navigate, site_configuration)
  })

  const onClickUser = () => {
    if(formik.values.user){
      openModalUserEdit(formik.values.user)
    } else{
      openModalUser()
    }
  }

  return (
    <GxForm onGx-submit={formik.submitForm}>
      <div className={styles['header']}>
        <div className={styles['header--subtitle']}>Создать задачу</div>
        <div className={styles['actions']}>
          <div className={styles['actions--status']}>Cтатус задачи:<span>Новая</span></div>
          <div className={styles['actions--group-btn']}>
            <GxButton onClick={() => navigate(site_configuration?.page_tasks)} className={styles['btn--actions']}>Отмена</GxButton>
            <GxButton className={styles['btn--actions']} type='submit'>Сохранить</GxButton>
          </div>
        </div>
      </div>
      <div className={styles['main']}>
        <div className={styles['main--left-block']}>
          <div className={styles['form']}>
            <div className={styles['form--item']}>
              <Input
                className={styles['form--input']}
                label='Название:'
                name='title'
                handleChange={(e:Record<string, any>)=>formik.setFieldValue('title', e.target.value)}
                value={formik.values.title}
              />
              <p className={styles['form--error']}>{formik.errors.title}</p>
            </div>
            <div className={cn(styles['form--container'], styles['form--mobile'])}>
              <div className={cn(styles['form--item'], styles['form--item__group'])}>
                <span className={styles['label']}>Тип:</span>
                <TypeTaskSelect
                  onChangeSelect={(selectedOption) => formik.setFieldValue('source', selectedOption &&  selectedOption.value)}
                  value={formik.values.source}/>
                <p className={styles['form--error']}>{formik.errors.source}</p>
              </div>
              <div className={cn(styles['form--item'], styles['form--item__group'])}>
                <span className={cn(styles['label'], styles['label--order'])}>Заявка:</span>
                <div className={styles['form--item__row']}>
                  <SelectOrders
                    onChange={(selectedOption) => formik.setFieldValue('order', selectedOption &&  selectedOption.value)}
                    value={formik.values.order}
                  />
                </div>
              </div>
            </div>
            {currentUser.user_status === 'staff' &&
            <Switcher
                label={!formik.values.flagStaff ? 'На себя' : 'На группу'}
                onGx-change={(e: any) => {
                  formik.setFieldValue('flagStaff', e.target.checked);
                  if(!e.target.checked){
                    formik.setFieldValue('user', currentUser.id);
                    formik.setFieldValue('groups', [])
                  }else{
                    formik.setFieldValue('user', null)
                  }
                  }
                }
                checked={formik.values.flagStaff}
                className={styles['switcher']}
            />
            }
            {currentUser.user_status === 'superuser' &&
                <>
              <div className={styles['form--container']}>
                <div className={cn(styles['form--item'], styles['form--item__group'])}>
                  <span className={cn(styles['label'])}>Персонал:</span>
                  <SelectStaff
                    value={formik.values.user}
                    name='user'
                    onChangeSelect={(selectedOption: any) => {
                      formik.setFieldValue('user', selectedOption && selectedOption);
                      formik.setFieldValue('groups', null)
                    }}
                    params={{
                      user_status: [TYPE_USER.STAFF, currentUser.user_status === TYPE_USER.SUPERUSER && TYPE_USER.SUPERUSER].join()
                    }}
                  />
                </div>
                <GxButton className={styles['btn']} onClick={onClickUser}>
                  <GxIcon className={styles['btn--icon']} src={ formik.values.user ? UserIcon : PlusIcon} />
                </GxButton>
                <p className={styles['form--error']}>{formik.errors.user}</p>
              </div>
              </>
            }
            {(formik.values.flagStaff || currentUser.user_status === 'superuser') &&
            <div className={styles['form--container']}>
              <div className={cn(styles['form--item'], styles['form--item__group'])}>
                <span className={styles['calendar__label']}>Группа:</span>
                <MultiSelectUsers
                    value={formik.values.groups}
                    onChangeSelect={(selectedOption) => {
                      formik.setFieldValue('groups', selectedOption && selectedOption);
                      formik.setFieldValue('user', null);
                    }}
                    flagStaff={!formik.values.flagStaff && currentUser.user_status !== 'superuser'}
                />
              </div>
              <p className={styles['form--error']}>{formik.errors.groups}</p>
            </div>
            }
            <div className={styles['form--item']}>
              <GxTextarea
                label='Опиcание:'
                value={formik.values.description}
                resize='none'
                className={cn(styles['form--input'], styles['form--input_textarea'])}
                onGx-change={(e: Record<string, any>) => formik.setFieldValue('description', e.target.value)}
              />
            </div>
            <div className={cn(styles['form--item'], styles['calendar'])}>
              <span className={styles['calendar__label']}>Сроки:</span>
              <DatePicker
                weekDays={weekDays}
                months={months}
                render={<CalendarInput />}
                format="DD/MM/YYYY HH:mm:ss"
                calendarPosition='top'
                weekStartDayIndex={1}
                containerStyle={{
                  width: '100%'
                }}
                plugins={[
                  <TimePicker position='bottom' />
                ]}
                onChange={(date: any) => formik.setFieldValue('deadline_at', dayjs(date).utc().format())}
              />
            </div>
            <div className={styles['file-upload']}>
              <span className={styles['file-upload--title']}>Файл:</span>
              <InputUploadFile name='attach' setFieldValue={formik.setFieldValue} />
            </div>
            <GxCheckbox
              className={styles['form--type']}
              checked={formik.values.is_urgent}
              onGx-change={(e: Record<string, any>) => formik.setFieldValue('is_urgent', e.target.checked)}>
              Срочная задача:
            </GxCheckbox>
          </div>
        </div>
        <div className={styles['main--right-block']}>
          <TabGroupsUser flag={tabGroups.usersTab.status} formik={formik} handleClickTab={handleClickTab} openModalCall={openModalCall}/>
          <TabGroupsRepeat flag={tabGroups.repeatTab.status} formik={formik} handleClickTab={handleClickTab}/>
          <TabGroupsReminder flag={tabGroups.reminderTab.status} formik={formik} handleClickTab={handleClickTab}/>
        </div>
      </div>
      <div className={cn(styles['actions'], styles['actions--footer'])}>
        <div className={styles['actions--group-btn']}>
          <GxButton onClick={() => navigate(site_configuration?.page_tasks)} className={styles['btn--actions']}>Отмена</GxButton>
          <GxButton className={styles['btn--actions']} type='submit'>Сохранить</GxButton>
        </div>
      </div>
    </GxForm>
  );
};

export default memo(CreateTask);

